import React, { memo, useState } from 'react'
import './styles.css'
import {
  IOrderByUnitItem,
  IOrdersByManager,
  IOrdersByManagerMonth,
} from '../../model/types/types'
import { Typography } from 'antd'
import { formatPrice } from 'src/react-app/pages_v2/utils'
import dayjs from 'dayjs'
import { SortOrder } from 'antd/lib/table/interface'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'

const { Title } = Typography

export interface OrdersByManagersTableProps {
  data: IOrdersByManager
}
const fDate = d => dayjs(d).format('DD/MM/YY')

class OfficeGroup {
  orders: IOrderByUnitItem[] = []
  office: string
  total: number = 0
  constructor(name: string) {
    this.office = name
  }
  add(el: IOrderByUnitItem) {
    this.orders.push(el)
  }
  calcItogi() {
    this.total = 0
    this.orders.forEach(el => {
      this.total += el.sum
    })
    return formatPrice(this.total)
  }
}

const OneTable = ({
  month,
  ordersByMonth
}: {
  month: string
  ordersByMonth: IOrdersByManagerMonth
}) => {
  const [dataSource, setDataSource] = useState(ordersByMonth.orders)

  // Группируем заказы по группам
  const groups = dataSource.reduce((acc, order, rowIndex) => {
    const offN = order.office
    if (!acc[offN]) {
      acc[offN] = new OfficeGroup(offN)
    }
    acc[offN].add(order)
    return acc
  }, {} as Record<string, OfficeGroup>)
  // Индексация строк
  let rI = 1
  Object.values(groups).forEach(g => {
    g.orders.forEach(o => {
      o.rowIndex = rI
      rI++
    })
  })
  //
  type filtersNames = 'sum' | 'orderDate'
  const [sortingOptions, setSortingOptions] = useState<Record<string, SortOrder>>({
    sum: null,
  })
  const toggleFilter = (filterName: filtersNames) => {
    setSortingOptions(prev => {
      const tmp = { ...prev }
      if (tmp[filterName] == 'ascend') {
        tmp[filterName] = 'descend'
      } else if (prev[filterName] == 'descend') {
        tmp[filterName] = null
      } else {
        tmp[filterName] = 'ascend'
      }
      return tmp
    })
  }
  const getIcon = (filterName: filtersNames) => {
    if (sortingOptions[filterName] == 'ascend') {
      return <CaretUpOutlined />
    } else if (sortingOptions[filterName] == 'descend') {
      return <CaretDownOutlined />
    } else {
      return null
    }
  }
  return (
    <div className="by-managers-table">
      <div>
        <Title level={5}>{month}</Title>
      </div>
      <div className="by-managers-table__crt">
        <table>
          <thead>
            <tr>
              <th style={{width: "5%"}}>№</th>
              <th style={{width: "15%"}}>Менеджер</th>
              <th style={{width: "20%"}}>Офис</th>
              <th style={{width: "10%"}}>Дата оплаты</th>
              <th style={{width: "10%"}}>Дата заявки</th>
              <th style={{width: "10%"}}>Договор</th>
              <th style={{width: "10%"}}>Номер производственного заказа</th>
              <th style={{width: "5%"}}>Сделка, дни</th>
              <th style={{width: "10%"}}>Клиент</th>
              <th style={{width: "10%"}} onClick={() => toggleFilter('sum')} className="sortable-col">
                <div className="th-icon">
                  Продажи
                  {getIcon('sum')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {Object.values(groups).map(group => {
              const tmp = group.orders.map((order, i) => (
                <tr key={month + i}>
                  <td>{order.rowIndex}</td>
                  <td>{order.manager}</td>
                  <td>{order.office}</td>
                  <td>{order.orderDate ? fDate(order.orderDate) : '-'}</td>
                  <td>{order.caseDate ? fDate(order.caseDate) : '-'}</td>
                  <td>{order.contractNum}</td>
                  <td>{order.productionNum}</td>
                  <td>{order.days || '-'}</td>
                  <td>{order.clientName}</td>
                  <td>{formatPrice(order.sum)}</td>
                </tr>
              ))
              tmp.push(
                <tr key={month + group.office} className="row-bold">
                  <td> - </td>
                  <td>Итог офиса</td>
                  <td>{group.office}</td>
                  <td colSpan={6}></td>
                  <td>{group.calcItogi()}</td>
                </tr>,
              )
              return tmp
            })}
          </tbody>
          <tfoot>
            <tr>
              <th>Всего</th>
              <th colSpan={8}></th>
              <th>{formatPrice(ordersByMonth.total)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  )
}

const OrdersByManagersTable = (props: OrdersByManagersTableProps) => {
  const { data } = props

  return (
    <div>
      {Array.from(data).map(([month, ordersByMonth], i) => (
        <OneTable month={month} ordersByMonth={ordersByMonth} key={i} />
      ))}
    </div>
  )
}

export default memo(OrdersByManagersTable)
